import React from 'react';
import { Content } from './shared';

const CignaAcupuncture = () => (
  <Content>
    Balance the flow of energy in your body and relieve pain with discounts at participating
    acupuncturists.
    <ol>
      <li>Visit the ChooseHealthy website and log in.</li>

      <li>Go to Acupuncture {'>'} Find a Provider.</li>

      <li>Call to set up an appointment. Don't forget your Cigna card!</li>
    </ol>
  </Content>
);

export default CignaAcupuncture;
